import { OfferingOptionModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';

class OfferingOptionService extends ApiService<OfferingOptionModel> {
        constructor() {
                super('offeringoption');
        }

        async getByIds(ids: number[]): Promise<OfferingOptionModel[]> {
                if (ids.length === 0) return [];
                const params = new URLSearchParams({ 
                        where: JSON.stringify({ id: ids }),
                        limit: '0' 
                });
                return this.getAll(params);
        }
}

export default new OfferingOptionService();
